var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import SvgIcon from '@material-ui/core/SvgIcon';
var WarningIcon = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon, _extends({
    ref: ref,
    viewBox: '0 0 24 24'
  }, R.omit(['pathBackgroundColor', 'pathColor'], props)), React.createElement('path', {
    d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
    fill: props.pathBackgroundColor || 'orange'
  }), React.createElement('path', {
    d: 'M1 21zm12 -3h-2v-2h2v2zm0 -4h-2v-4h2v4z',
    fill: props.pathColor || 'black'
  }));
});
WarningIcon.propTypes = {
  pathBackgroundColor: PropTypes.string,
  pathColor: PropTypes.string
};
export default WarningIcon;